import React from 'react';

import AppleIcon from './images/apple.svg';
import FbIcon from './images/fb.svg';
import GoogleIcon from './images/google.svg';
import {
  BarLabel,
  Container,
  SocialMediaIcons,
  SocialMediaButton,
  SocialMediaIcon,
  BarLabelContainer,
  BarLabelLine
} from './socialMediaLoginBar.styled';
import { SocialMediaLoginBarProps } from './socialMediaLoginBar.types';

export const SocialMediaLoginBar: React.FC<SocialMediaLoginBarProps> = (props: SocialMediaLoginBarProps): JSX.Element => {
  const { className, barLabel, position = 'top' }: SocialMediaLoginBarProps = props;

  return (
    <Container className={className}>
      {position === 'top' && (
        <BarLabelContainer $margin='0 0 24px'>
          <BarLabelLine />
          <BarLabel>{barLabel}</BarLabel>
        </BarLabelContainer>
      )}
      <SocialMediaIcons>
        <SocialMediaButton>
          <SocialMediaIcon src={GoogleIcon} />
        </SocialMediaButton>
        <SocialMediaButton>
          <SocialMediaIcon src={FbIcon} />
        </SocialMediaButton>
        <SocialMediaButton>
          <SocialMediaIcon src={AppleIcon} />
        </SocialMediaButton>
      </SocialMediaIcons>
      {position === 'bottom' && (
        <BarLabelContainer $margin='24px 0 0'>
          <BarLabelLine />
          <BarLabel>{barLabel}</BarLabel>
        </BarLabelContainer>
      )}
    </Container>
  );
};
